import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import axios from 'axios';

const CreateServiceTypeModal = ({ show, handleClose }) => {
  const [newServiceType, setNewServiceType] = useState({
    name: '',
    description: '',
    image_url: '',
    button_content: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewServiceType({ ...newServiceType, [name]: value });
  };

  const handleSaveClick = () => {
    console.log(newServiceType);
    axios.post(`${process.env.REACT_APP_API_URL}/services/createServiceType`, newServiceType)
      .then(response => {
        handleClose();
      })
      .catch(error => {
        console.error("Error creating service type:", error);
      });
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Crear Nuevo Tipo de Servicio</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="formServiceTypeName">
            <Form.Label>Nombre del Tipo de Servicio</Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={newServiceType.name}
              onChange={handleInputChange}
            />
          </Form.Group>
          <Form.Group controlId="formServiceTypeDescription">
            <Form.Label>Descripción</Form.Label>
            <Form.Control
              type="text"
              name="description"
              value={newServiceType.description}
              onChange={handleInputChange}
            />
          </Form.Group>
          <Form.Group controlId="formServiceTypeImageUrl">
            <Form.Label>URL de la Imagen</Form.Label>
            <Form.Control
              type="text"
              name="image_url"
              value={newServiceType.image_url}
              onChange={handleInputChange}
            />
          </Form.Group>
          <Form.Group controlId="formServiceTypeButtonContent">
            <Form.Label>Contenido del Botón</Form.Label>
            <Form.Control
              type="text"
              name="button_content"
              value={newServiceType.button_content}
              onChange={handleInputChange}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={handleSaveClick}>
          Guardar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CreateServiceTypeModal;
